import React from 'react';
import classNames from 'classnames';
import css from './InfoTile.css'; // Importujemy dedykowane style

const InfoTile = ({ title, headerAction, children, className }) => {
  return (
    <section className={classNames(css.contentSection, className)}>
      <div className={css.sectionHeaderRow}>
        <h3 className={css.sectionHeading}>{title}</h3>
        
        {headerAction && (
          <div className={css.actionWrapper}>
            {headerAction}
          </div>
        )}
      </div>
      
      <div className={css.sectionBody}>
        {children}
      </div>
    </section>
  );
};

export default InfoTile;